import { imageUrl } from "@/lib/api";

const TCMark = ({ className }) => (
  <svg viewBox="0 0 64 64" className={className} data-testid="logo-mark-tc">
    <rect width="64" height="64" rx="15" fill="#0B1E2E" />
    <rect x="1.5" y="1.5" width="61" height="61" rx="13.5" fill="none" stroke="rgba(56,189,248,0.35)" strokeWidth="1.5" />
    <text x="32" y="38" textAnchor="middle" fontFamily="Fraunces, Georgia, serif" fontWeight="700" fontSize="27" fill="#38BDF8">TC</text>
    <line x1="16" y1="47" x2="48" y2="47" stroke="#E2C08D" strokeWidth="2.4" strokeLinecap="round" />
    <line x1="22" y1="53" x2="42" y2="53" stroke="#E2C08D" strokeWidth="2.4" strokeLinecap="round" opacity="0.45" />
  </svg>
);

const AgriMark = ({ className }) => (
  <svg viewBox="0 0 64 64" className={className} data-testid="logo-mark-agri">
    <rect width="64" height="64" rx="15" fill="#0B2015" />
    <rect x="1.5" y="1.5" width="61" height="61" rx="13.5" fill="none" stroke="rgba(16,185,129,0.35)" strokeWidth="1.5" />
    <path d="M32 13 C44 21 47 35 32 50 C17 35 20 21 32 13 Z" fill="none" stroke="#10B981" strokeWidth="2.6" strokeLinejoin="round" />
    <path d="M32 50 L32 30" stroke="#10B981" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M32 38 C36 34 40 33 43 33 M32 42 C28 38 24 37 21 37" stroke="#10B981" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.7" />
    <circle cx="47" cy="17" r="4" fill="#E2C08D" />
  </svg>
);

const RestroMark = ({ className }) => (
  <svg viewBox="0 0 64 64" className={className} data-testid="logo-mark-restro">
    <rect width="64" height="64" rx="15" fill="#1C1410" />
    <rect x="1.5" y="1.5" width="61" height="61" rx="13.5" fill="none" stroke="rgba(226,192,141,0.35)" strokeWidth="1.5" />
    <path d="M14 40 a18 18 0 0 1 36 0 Z" fill="none" stroke="#E2C08D" strokeWidth="2.6" strokeLinejoin="round" />
    <line x1="10" y1="46" x2="54" y2="46" stroke="#E2C08D" strokeWidth="2.6" strokeLinecap="round" />
    <circle cx="32" cy="19" r="2.6" fill="#E2C08D" />
    <path d="M24 33 a9 9 0 0 1 6 -6" stroke="#E2C08D" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.6" />
  </svg>
);

const MARKS = {
  "tracksure-connect": TCMark,
  "nayagarh-agriverse": AgriMark,
  "myrestrohub": RestroMark,
};

const WIDE = new Set(["zepzyo", "waah-circle"]);

const VentureLogo = ({ v, size = "h-14 w-14" }) => {
  const Mark = MARKS[v.slug];
  const big = size.includes("28") || size.includes("36");
  if (v.logo_url) {
    const cls = WIDE.has(v.slug) ? (big ? "h-28 w-56 p-4" : "h-14 w-28 p-2.5") : `${size} p-1.5`;
    return (
      <div className={`${cls} rounded-xl bg-white border border-white/10 flex items-center justify-center overflow-hidden`}>
        <img src={imageUrl(v.logo_url)} alt={`${v.name} logo`} className="max-h-full max-w-full object-contain" data-testid={`venture-logo-${v.slug}`} />
      </div>
    );
  }
  if (Mark) return <Mark className={`${size} rounded-xl`} />;
  const initials = v.name.split(/\s+/).map((w) => w[0]).slice(0, 2).join("");
  return (
    <div className={`${size} rounded-xl border border-[#E2C08D]/30 bg-[#E2C08D]/8 flex items-center justify-center font-display ${big ? "text-4xl" : "text-xl"} font-semibold text-[#E2C08D]`} data-testid={`venture-logo-${v.slug}`}>
      {initials}
    </div>
  );
};

export default VentureLogo;
